import React, { useRef, useEffect } from 'react';
import { FaGithub, FaLinkedin, FaArrowRight, FaFileDownload } from 'react-icons/fa';

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
const T = `transform 0.4s ${EASE}, box-shadow 0.4s ${EASE}`;

const Home = ({ theme }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const handleMouse = (e) => {
      const rect = section.getBoundingClientRect();
      section.style.setProperty('--mx', (e.clientX - rect.left) + 'px');
      section.style.setProperty('--my', (e.clientY - rect.top) + 'px');
    };
    section.addEventListener('mousemove', handleMouse);
    return () => section.removeEventListener('mousemove', handleMouse);
  }, []);

  const btnPrimary = {
    display: 'inline-flex', alignItems: 'center', gap: '8px',
    padding: '13px 28px', background: 'var(--accent)', color: theme === 'dark' ? '#0D0D0D' : '#FFFFFF',
    fontWeight: 600, fontSize: '0.88rem', border: 'none',
    borderRadius: '100px', cursor: 'pointer', textDecoration: 'none',
    transform: 'translateY(0)',
    transition: `${T}, background 0.3s ease`,
  };

  const btnGhost = {
    display: 'inline-flex', alignItems: 'center', gap: '8px',
    padding: '13px 28px', background: 'transparent', color: 'var(--text-primary)',
    fontWeight: 500, fontSize: '0.88rem',
    border: '1px solid var(--border-subtle)',
    borderRadius: '100px', cursor: 'pointer', textDecoration: 'none',
    transform: 'translateY(0)',
    transition: `${T}, border-color 0.3s ease, background 0.3s ease, color 0.3s ease`,
  };

  const socialBtn = {
    width: '42px', height: '42px',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    borderRadius: '10px', border: '1px solid var(--border-subtle)',
    color: 'var(--text-muted)', textDecoration: 'none', cursor: 'pointer',
    transform: 'translateY(0)',
    transition: `${T}, color 0.3s ease, background 0.3s ease, border-color 0.3s ease`,
  };

  const onPrimaryIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(var(--accent-rgb),0.35)'; e.currentTarget.style.background = 'var(--accent-hover)'; };
  const onPrimaryOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.background = 'var(--accent)'; };

  const onGhostIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(var(--accent-rgb),0.12)'; e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-soft)'; e.currentTarget.style.color = 'var(--accent)'; };
  const onGhostOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-primary)'; };

  const onSocialIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(var(--accent-rgb),0.15)'; e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-soft)'; e.currentTarget.style.borderColor = 'var(--border-hover)'; };
  const onSocialOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; };

  return (
    <section id="home" className="home-section" ref={sectionRef}>
      <div className="hero-radar" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />

      <div className="container hero-content" style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 24px' }}>
        <div className="hero-overline">
          <span className="status-dot"></span>
          <span className="line"></span>
          Disponible para proyectos
        </div>

        <h1 className="hero-title">
          Hola, soy
          <span className="line-2">Andres Coronel</span>
        </h1>

        <p className="hero-description">
          Desarrollador <strong>Full Stack</strong> que fusiona
          código limpio con diseño estratégico. Especializado en
          arquitecturas escalables y experiencias digitales memorables.
        </p>

        <div className="hero-actions">
          <a href="#projects" style={btnPrimary} onMouseEnter={onPrimaryIn} onMouseLeave={onPrimaryOut}>
            Ver Proyectos <FaArrowRight size={13} />
          </a>
          <a href="/cv.pdf" download="Andres_Coronel_CV.pdf" style={btnGhost} onMouseEnter={onGhostIn} onMouseLeave={onGhostOut}>
            <FaFileDownload size={15} /> Descargar CV
          </a>
        </div>

        <div className="hero-socials">
          <a href="https://github.com/AndressCoronel" target="_blank" rel="noreferrer" style={socialBtn} aria-label="GitHub" onMouseEnter={onSocialIn} onMouseLeave={onSocialOut}>
            <FaGithub size={18} />
          </a>
          <a href="https://www.linkedin.com/in/andres-coronel-164767263/" target="_blank" rel="noreferrer" style={socialBtn} aria-label="LinkedIn" onMouseEnter={onSocialIn} onMouseLeave={onSocialOut}>
            <FaLinkedin size={18} />
          </a>
        </div>
      </div>

      <div className="scroll-cue" aria-hidden="true">
        <span>scroll</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Home;
